<template>

    <Tree
        :tree-items="treeItemsMenus"
        :multiple-expandable="true"
        :auto-indent="true"
        :auto-indent-width="10"
        class="tree-container"
    >
        <template #internal="{node, depth,toggle}">
            <div  class="menu-wrapper cursor" @click="toggle">
                <div class="menu-text-style">└ {{ node.title }}</div>
                <div  class="menu-info-desc">
                    <v-icon
                        small
                        v-if="depth===2" class="plus-button-style"
                        @click.stop="plusButtonClick(node)"
                    >
                        mdi-plus
                    </v-icon>
                </div>

            </div>
        </template>

        <template #leaf="{node,depth}" >
            <div class="menu-wrapper cursor" @click="manualClick(node,depth)"
                 :class="clickManualBackground(node,depth)"
            >
                <div class="menu-text-style">└ {{ node.title }}</div>
                <div class="menu-info-desc">
                    <div v-if="depth===3" class="menu-moving-arrow-wrapper">
                        <!--화살표 위 , 비어있는 메뉴얼 메뉴는 해당 없음-->
                        <v-icon
                            v-if="node.manualId !== -1"
                            small
                            :class="manualStatus(node,'up') && 'menu-moving-arrow'"
                            :color="arrowMenuDisable(node,'up')"
                            @click.stop="moveArrowButtonClick(node,'up')"
                        >
                            mdi-arrow-up-bold-box-outline
                        </v-icon>
                        <!--화살표 아래 , 비어있는 메뉴얼 메뉴는 해당 없음-->
                        <v-icon
                            v-if="node.manualId !== -1"
                            small
                            :class="manualStatus(node,'down') && 'menu-moving-arrow'"
                            :color="arrowMenuDisable(node,'down')"
                            @click.stop="moveArrowButtonClick(node,'down')"
                        >
                            mdi-arrow-down-bold-box-outline
                        </v-icon>
                    </div>
                    <!--depth 2에서의 +버튼튼-->
                    <v-icon
                        small
                        v-if="depth===2" class="plus-button-style"
                        @click.stop="plusButtonClick(node)"
                    >
                        mdi-plus
                    </v-icon>
                </div>
            </div>
        </template>

    </Tree>
</template>

<script>
/**
 * 메뉴얼에서 메뉴부분 컨포넌트 입니다
 * 정책임님이 주신 slot으로 구성된 Tree.vue 컴포넌트를 사용하여 메뉴의 하이라키 구조를 구성하고있고
 * 우측 플러스 버튼 , 화살표 버튼 , 3depth(메뉴얼) 클릭시 , toggle 등 수행합니다
 * 그리고 추가적으로 다른 메뉴 , 다른 동작을 수행시 dialog로 여부를 묻고 비어있는 메뉴얼 메뉴도 생성합니다
 * 동작을 실행할껀지에 대한 여부만 판단하고 나머지 부분은 $emit으로 데이터를 전달하여
 * NewManual.vue 컴포넌트에서 동작을 수행합니다.
 */

import Tree from "@/views/newManual/TreeMenuSlot/Tree";

export default {
    name: "NewManualTreeMenuSlot",
    components: {
        Tree,
    },
    props: {
        treeItemsMenus: {
            type: Array,
            default: ()=>[]
        },
        menus:{
            type:Array,
            default: ()=>[]
        },
        clickMenuId:{
            type:Number,
            default: undefined
        }

    },
    methods: {
        /**
         * 해당 메뉴얼 기준으로 위 아래 메뉴얼이 있는지 없는지에 따라 화살표 버튼을 다른 색깔을 표기합니다.
         */
        arrowMenuDisable(manual,arrow) {
            let arrowButtonColor = "#cccccc"
            const menuStatus = this.manualStatus(manual,arrow)
            arrowButtonColor = menuStatus ? '#000000' : arrowButtonColor
            return arrowButtonColor
        },


        /**
         * 해당 메뉴얼 기준으로 앞에 또는 뒤에 있는 메뉴얼을 찾고 반환합니다.
         * @param manual
         * @param arrow
         * @returns {{backMenu: *, frontMenu: *}}
         */
        manualStatus(manual,arrow){
            let frontMenu = undefined
            let backMenu = undefined

            /**
             * 클릭한 메뉴얼과 같은 parentId를 갖는 메뉴얼을 찾습니다.
             * 단 비어있는 메뉴얼 메뉴는 제외됩니다.
             * @type {*[]}
             */
            const sameParentMenu = this.menus.filter((menu)=> {
                return menu.parentId === manual.parentId && menu.manualId!==-1
            })

            /**
             * sequence 따라 오름차순 정렬을 합니다(index로 순서 파악하려고 합니다)
             */
            sameParentMenu.sort((a, b)=> a.sequence - b.sequence)

            /**
             * 클릭한 메뉴얼이 찾은 메뉴얼중 어느 위치에 있는지 확인합니다.
             * @type {number}
             */
            const findClickMenuIndex = sameParentMenu.findIndex((menu) => menu.manualId === manual.manualId)

            /**
             * 클릭한 메뉴에서 위에 아래 메뉴얼이 있는지 여부와 어떤 메뉴얼인지
             * 파악후 frontMenu backMenu에 데이터를 넣는다.
             */
            if(findClickMenuIndex ===0 && sameParentMenu.length === 1){ //첫번째인데 다른 메뉴얼이 없을때
                frontMenu = undefined
                backMenu = undefined
            }else if(findClickMenuIndex ===0){//첫번째인데 다른 메뉴얼이 있을때
                frontMenu = undefined
                backMenu= sameParentMenu[findClickMenuIndex+1]
            }else if(findClickMenuIndex === sameParentMenu.length-1){//마지막인데 다른 메뉴얼이 있을때
                frontMenu = sameParentMenu[findClickMenuIndex-1]
                backMenu= undefined

            }else {
                frontMenu = sameParentMenu[findClickMenuIndex-1]
                backMenu= sameParentMenu[findClickMenuIndex+1]
            }
            if(arrow ==='up') return frontMenu
            else return backMenu
        },

        /**
         * 클릭했을때 저장한 manualId와 맞으면 background 변경합니다.
         */
        clickManualBackground(manual,depth){
            if(depth!==3) return;
            return (manual.manualId ===this.clickMenuId || manual.manualId ===-1) && 'click-manual-background'
        },
        /**
         * 2depth에 있는 메뉴 우측 +버튼 클릭시
         * @param node
         */
        plusButtonClick(clickMenu){
            //비어있는 메뉴 중복 생성을 방지하기 위해 만들었습니다
            const isBlankManualSameMenu = () => {
                if(!clickMenu.children) return true
                return clickMenu.children.every(manual => manual.manualId!==-1)
            }
            if(!isBlankManualSameMenu()) return``
            this.$emit("moving-write-detail",clickMenu)
        },
        /**
         * 3depth에 있는 메뉴 클릭시
         * @param node
         * @param depth
         */
        manualClick(clickMenu,depth){
            if(depth===3){
                this.$emit("moving-select-detail",clickMenu)
            }
        },
        /**
         * 위 아래 화살표 방향키를 눌렀을때 메뉴가 이동합니다.
         * 클릭한 메뉴얼의 sequence 보다 작은 or 큰 메뉴얼이 없다면 아래 수행 안하고 return
         * 있다면 emit으로 데이터를 올리는데 click한 메뉴얼과 그 위 or 아래 메뉴얼을 전달합니다.
         */
        moveArrowButtonClick(clickMenu,arrow){
            const menuStatus = this.manualStatus(clickMenu,arrow)
            if(!menuStatus) return //앞에나 뒤에 메뉴얼이 없다면 아무런 동작도 수행하지 않습니다.
            this.$emit("moving-manual-rq",clickMenu,menuStatus)
        }
    },

}
</script>

<style scoped>
/*메뉴 부분입니다.*/
.cursor {
    cursor: pointer;
}
.cursor:hover {
    background: #ddd;
}
.menu-info-desc{
    display: flex;
    align-items: center;
}
.menu-wrapper{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.tree-container{
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%
}
.plus-button-style{
    cursor: pointer;
    margin-right: 5px;
}
.plus-button-style:hover{
    color: #0575E6;
}
.menu-moving-arrow-wrapper{
    margin-right: 5px;
}
.menu-text-style{
    font-size: 12px;
}
.menu-moving-arrow{
    cursor: pointer;
}
.menu-moving-arrow:hover{
    color: #0575E6 !important;
}
.click-manual-background {
    background-color: #DCEDFD;
    border-radius: 3px;
}
</style>